import axios from 'axios';

export async function listBooths({ page = 1, limit = 50, eventId, organizationId } = {}) {
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };
  const params = { page, limit };
  if (eventId) params.eventId = eventId;
  if (organizationId) params.organizationId = organizationId;
  const res = await axios.get('/api/booths', { headers, params });
  return res.data;
}

// Create booths for one or more events
export async function createBooths(payload) {
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };
  const res = await axios.post('/api/booths', payload, { headers });
  return res.data;
}

export async function updateBooth(id, payload) {
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };
  const res = await axios.put(`/api/booths/${id}`, payload, { headers });
  return res.data;
}

export async function deleteBooth(id) {
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };
  const res = await axios.delete(`/api/booths/${id}`, { headers });
  return res.data;
}

// Bulk delete booths
export async function bulkDeleteBooths(boothIds) {
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };
  const res = await axios.delete('/api/booths/bulk-delete', {
    headers,
    data: { boothIds }
  });
  return res.data;
}

export async function updateBoothRichSections(id, sections) {
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };
  const res = await axios.put(`/api/booths/${id}/rich-sections`, { sections }, { headers });
  return res.data;
}

export async function updateBoothEmployerPageSections(id, sections) {
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };
  const res = await axios.put(`/api/booths/${id}/employer-page-sections`, { sections }, { headers });
  return res.data;
}

// Resolve booth by invite slug for job seeker queue links
// Optional event: event slug or id so multi-event booths join the correct event
// Optional test: the code from a test link (/queue/<booth>/test/<code>)
export async function resolveBoothInvite(slug, { event, test } = {}) {
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };
  const params = {};
  if (event) params.event = event;
  if (test) params.test = test;
  const res = await axios.get(`/api/booths/invite/${encodeURIComponent(slug)}`, { headers, params });
  return res.data;
}

// Get events assigned to a booth
export async function getBoothEvents(boothId) {
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`/api/booths/${boothId}/events`, { headers });
  return res.data.events || [];
}

// The booth's test queue link code ({ testInviteToken: null } until one is made)
export async function getBoothTestLink(id) {
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`/api/booths/${id}/test-link`, { headers });
  return res.data;
}

// Make the booth's test queue link code, replacing (and disabling) any earlier one
export async function createBoothTestLink(id) {
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };
  const res = await axios.post(`/api/booths/${id}/test-link`, {}, { headers });
  return res.data;
}
